<template>
  <v-container class="pa-6">

    <!-- Tabla de Reportes de Persona -->
    <v-row class="ma-0 mt-5 mb-4">
      <v-col class="pa-0 my-4">
        <div style="font-family: 'montserrat-bold'; font-size: 32px; color: black;">{{ "Historial de reportes" }}</div>
        <div style="font-family: 'montserrat-regular'; font-size: 14px;"> {{ "Aqui podras visualizar tus reportes." }}</div>
      </v-col>
    </v-row>
    <h3 class="my-4">Reportes de Persona</h3>
    <v-data-table
      class="d-none d-sm-block"
      :headers="headersPerson"
      :items="personReports"
      :items-per-page="5"
      hide-default-header
      >
      <template v-slot:header>
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">User</th>
            <th class="header__title center">Nombre</th>
            <th class="header__title center">CURP</th>
            <th class="header__title center">RFC</th>
            <th class="header__title center">Correo</th>
            <th class="header__title right">Acciones</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.sId">
            <td class="table__item">{{ item.userCreate }}</td>
            <td class="table__item">{{ item.nombres }} {{ item.apellido_paterno }} {{ item.apellido_materno }}</td>
            <td class="table__item">{{ item.curp }}</td>
            <td class="table__item">{{ item.rfc }}</td>
            <td class="table__item">{{ item.correo_electronico }}</td>
            <td class="table__item">
              <v-btn color="black" icon @click="verReportePersona(item.sId)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>

    <h3 class="my-4 mt-8">Reportes de Empresa</h3>
    <v-data-table
      class="d-none d-sm-block"
      :headers="headersCompany"
      :items="companyReports"
      :items-per-page="5"
      hide-default-header
      >
      <template v-slot:header>
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">User</th>
            <th class="header__title center">Razón Social</th>
            <th class="header__title center">RFC</th>
            <th class="header__title center">Marca</th>
            <th class="header__title center">Dominio</th>
            <th class="header__title right">Acciones</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.sId">
            <td class="table__item">{{ item.userCreate }}</td>
            <td class="table__item">{{ item.razon_social }}</td>
            <td class="table__item">{{ item.rfc }}</td>
            <td class="table__item">{{ item.marca }}</td>
            <td class="table__item">{{ item.dominio }}</td>
            <td class="table__item">
              <v-btn color="black" icon @click="verReporte(item.sId)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      personReports: [],
      companyReports: [],
      headersPerson: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'CURP', value: 'curp' },
        { text: 'RFC', value: 'rfc' },
        { text: 'Correo', value: 'correo_electronico' },
        { text: 'Acciones', value: 'acciones', sortable: false },
      ],
      headersCompany: [
        { text: 'Razón Social', value: 'razon_social' },
        { text: 'RFC', value: 'rfc' },
        { text: 'Marca', value: 'marca' },
        { text: 'Dominio', value: 'dominio' },
        { text: 'Acciones', value: 'acciones', sortable: false },
      ],
    };
  },
  created() {
    this.loadReports();
  },
  methods: {
    async loadReports() {
      try {
        this.isLoading = true;
        DB.get(`${URI}/api/v1/en/administrator/reports`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        }).then((response) => {
          this.isLoading = false;
          this.personReports = response.data.data.personReports;
          this.companyReports = response.data.data.companyReports;
        }).catch((error) => {
          this.isLoading = false;
          this.mixError(error.response?.data?.message || "Ocurrió un error");
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
        });

      } catch (err) {
        console.error('Error cargando reportes:', err);
      }
    },
    verReporte(id) {
      this.$router.push(`/reportEnterprise/${id}`);
    },
    verReportePersona(id) {
      this.$router.push(`/reportPerson/${id}`);
    },
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.landing[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.header__title {
  font-weight: 600;
  padding: 12px;
  text-align: left;
  color: #2a2a2a;
}
.table__item {
  padding: 10px;
  font-size: 14px;
  color: #333;
}
</style>
